import { Component, OnInit, Inject, Input } from '@angular/core';
import {
  Router,
  NavigationStart,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { environment } from 'src/environments/environment';
// Services
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from '../../services/api/message.service';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { CommonService } from 'src/app/services/api/common.service';
import { Subscription } from 'rxjs';
// import { Intercom } from '@supy-io/ngx-intercom';
import { MixpanelService } from 'src/app/mixpanel.service';
import { SwichBackToPythonComponent } from '../swich-back-to-python/swich-back-to-python.component';
import { NgClass, NgIf } from '@angular/common';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { DirectivesModule } from 'src/app/directives.module';

import Intercom from '@intercom/messenger-js-sdk';
@Component({
  selector: 'app-tracer-header',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    RouterLink,
    RouterLinkActive,
    SwichBackToPythonComponent,
    CommonAnnouncementComponent,
    DirectivesModule,
  ],
  templateUrl: './tracer-header.component.html',
  styleUrl: './tracer-header.component.scss'
})
export class TracerHeaderComponent {
  public schoolProps!: SchoolData;
  plan: any;
  title: any;
  sub!: Subscription;
  languages = [];
  schoolLogo: any;
  current_plan: any;
  activateScript: boolean = false;
  from_page_cookie: any;
  header: any;
  hideHeader: boolean = false;
  currentUrl: any;
  @Input() announcementData = ''; // Your dynamic message

  constructor(
    private authService: AuthenticationService,
    @Inject(Router) private router: Router,
    private commonService: CommonService,
    private sharedService: SharedService,
    // public intercom: Intercom,
    private mixpanelService: MixpanelService
  ) { }
  ngOnInit(): void {

    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');

  }
  backToAdmin() {
    this.authService.loggedOut();
    if (this.router) {
      this.router.ngOnDestroy();
    }
    window.open(environment.backToAdmin, '_self');
  }
  backToCoOrdinator() {
    this.authService.loggedOutCo();
    if (this.router) {
      this.router.ngOnDestroy();
    }
  }
  backToGroup() {
    this.authService.loggedOut();
    if (this.router) {
      this.router.ngOnDestroy();
    }
    window.open(environment.backToGroup, '_self');
  }
  logout() {
    if (localStorage.getItem('bookingSchool') == 'true') {
      this.authService.loggedOut();
      if (this.router) {
        this.router.ngOnDestroy();
      }
    } else {
      this.authService.loggedOut();
      if (this.router) {
        this.router.ngOnDestroy();
      }
    }
  }
}
